export default {
    authhostname: 'https://auth.yasnah.com',
    apihostname: 'https://api.yasnah.com'
 }